<template>
  <container
    subHeaderTitle="세이프가드·금융사기방지<br /><b>고객센터</b>"
    :subHeaderText="title"
    subHeaderAlign="center"
  >
    <section class="form-area mb-180">
      <v-container class="py-0">
        <v-row justify="center">
          <v-col cols="12" md="6" sm="8">
            <v-divider class="mb-8" />
            <h3 class="help-info" v-html="content"></h3>
            <v-divider class="my-8" />
            <p>[고객센터]</p>
            <div class="pl-5 mt-2">
              <ul>
                <li>연락처 : 1688-4102</li>
                <li>업무시간 : 09:00 ~ 18:00 (주말, 공휴일 휴무)</li>
                <li>점심시간 : 12:00 ~ 13:00</li>
              </ul>
            </div>
            <div class="mt-12 mb-16 text-center">
              <v-btn class="result" rounded large depressed color="primary" v-if="result == 'SUCCESS'" @click.stop="$router.push({ name: 'Support' })">완료</v-btn>
              <v-btn class="result" rounded large depressed color="primary" v-else @click.stop="failCall()">확인</v-btn>
              <v-btn v-if="type === 'contract' && result === 'LIMIT'" class="result" style="margin-left: 8px" rounded large depressed color="primary" @click.stop="clearLimit()">가입제한 해제</v-btn>
            </div>
          </v-col>
        </v-row>
      </v-container>
    </section>

    <!-- router Param 없을때 -->
    <v-dialog v-model="returnDialog" persistent max-width="290">
      <v-card>
        <v-card-text class="pt-8 text-center">
          <v-icon x-large class="mb-4">mdi-alert-circle-outline</v-icon>
          <h4>정상적인 접근이 아닙니다.</h4>
        </v-card-text>
        <v-card-actions>
          <v-spacer></v-spacer>
          <v-btn color="primary" text @click.stop="goReturn()">확인</v-btn>
        </v-card-actions>
      </v-card>
    </v-dialog>
  </container>
</template>

<script>
import Container from "@/pages/container/index.vue";
import PassSafeGuardResult from "@/views/csCenter/PassSafeGuardResult.vue";

export default {
  mixins: [PassSafeGuardResult],
  name: "PassSafeGuardResult",
  components: {
    Container
  },
  methods: {
    failCall() {
      let type = this.type; // contract / termination / compensation

      if (type === "contract") {
        this.$router.push({ name: "PassSafeguardContract" });
      } else if (type === "termination") {
        this.$router.push({ name: "PassSafeguardTermination" });
      } else if (type === "compensation") {
        this.$router.push({ name: "PassSafeguardCompensation" });
      }
    },
    goReturn() {
      this.$router.push({ name: "Support" });
    }
  }
};
</script>
